export enum InputType {
  File = 'file'
}
